import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { Gift, Check, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

interface WelcomeCreditsCardProps {
  creditsRemaining: number;
  creditsMonthly: number;
}

export function WelcomeCreditsCard({ creditsRemaining, creditsMonthly }: WelcomeCreditsCardProps) {
  const progressPercent = Math.min((creditsRemaining / creditsMonthly) * 100, 100);

  return (
    <Card className="glass-card-strong hover-lift transition-all border-2 border-dashed border-primary/30">
      <CardHeader>
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-full bg-gradient-to-r from-amber-500/20 to-orange-500/20 flex items-center justify-center">
            <Gift className="h-5 w-5 text-amber-600 dark:text-amber-400" />
          </div>
          <div>
            <CardTitle className="text-lg">Welcome Credits</CardTitle>
            <CardDescription>Your free credits to get started</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Credits Display */}
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Credits remaining</span>
            <span className="text-2xl font-bold text-primary">
              {creditsRemaining}
            </span>
          </div>
          
          <Progress value={progressPercent} className="h-3" />
          
          <p className="text-xs text-muted-foreground text-center">
            {creditsRemaining} of {creditsMonthly} welcome credits
          </p>
        </div>

        {/* Benefits */}
        <div className="space-y-2 py-3 border-y">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Check className="h-4 w-4 text-green-500" />
            <span>Never expire</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Check className="h-4 w-4 text-green-500" />
            <span>Use for any feature</span>
          </div>
        </div>

        {/* CTA */}
        <div className="space-y-3">
          <Button 
            asChild 
            className="w-full bg-gradient-to-r from-primary to-purple-600 hover:from-primary/90 hover:to-purple-600/90"
            size="lg"
          >
            <Link to="/plans">
              <Sparkles className="mr-2 h-4 w-4" />
              Subscribe for More Credits
            </Link>
          </Button>
          
          <p className="text-xs text-center text-muted-foreground">
            Unlock Smart Categories, Smart Notes, monthly credit renewals, and more.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
